import { useState, useEffect } from 'react'
import { Booking } from '../types'

const STORAGE_KEY = 'ptc-bookings'

export function useBookings() {
  const [bookings, setBookings] = useState<Booking[]>([])

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      try {
        setBookings(JSON.parse(stored))
      } catch (e) {
        console.error('Failed to parse bookings', e)
      }
    }
  }, [])

  const saveBooking = (booking: Booking) => {
    const updated = [...bookings, booking]
    setBookings(updated)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
  }

  const deleteBooking = (id: string) => {
    const updated = bookings.filter((b) => b.id !== id)
    setBookings(updated)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
  }

  const isSlotBooked = (date: string, time: string) => {
    return bookings.some((b) => b.date === date && b.time === time)
  }

  const getBookingsByDate = (date: string) => {
    return bookings
      .filter((b) => b.date === date)
      .sort((a, b) => a.time.localeCompare(b.time))
  }

  return {
    bookings,
    saveBooking,
    deleteBooking,
    isSlotBooked,
    getBookingsByDate,
  }
}
